import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
import { CheckIcon } from 'lucide-react';
import TestButton from '../TestButton';
export function FinalCTASection() {
  const benefits = ['Descarga inmediata (en 2 minutos tenés todo)', 'Garantía de 30 días o 100% de devolución', 'Acceso de por vida a todo el contenido', 'Soporte prioritario en la comunidad'];
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-section py-12 md:py-16 px-4 md:px-8 relative overflow-hidden" data-id="element-103" data-mp="39boluk5am271">
      {/* Subtle bottom gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-gold/5 to-transparent pointer-events-none" data-id="element-104" data-mp="3e3gbmsgmk3w4" />

      <div className="max-w-3xl mx-auto relative z-10 space-y-16" data-id="element-105" data-mp="2gmr20clfnxc6">
        {/* Main Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center space-y-10" data-id="element-106" data-mp="2lk9doaqu4qnv">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-black leading-tight" data-id="element-107" data-mp="1x4phwc4jmsdy">
            Tus próximos 21 días pueden cambiar{' '}
            <span className="text-gradient-gold" data-id="element-108" data-mp="1s5uu0vrpydmz">el resto de tu vida</span>
          </h2>

          <div className="flex justify-center" data-id="element-109" data-mp="1o641onmjnpgc">
            <CTAButton section="final_cta" onClick={scrollToOffer} className="text-lg md:text-xl" data-id="element-110" data-mp="1j5pxxhrz71o4" />
          </div>

          <div style={{
          position: 'absolute',
          left: '-9999px',
          top: '-9999px'
        }} data-id="element-111" data-mp="1e5k17n6umoz6">
            <TestButton data-id="element-112" data-mp="198k1rv4i8kh1" />
          </div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto pt-4" data-id="element-113" data-mp="38kmkh35b1atn">
            {benefits.map((benefit, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1 + 0.4
          }} className="flex items-center gap-3 justify-start bg-white/[0.025] p-4 rounded-[3px] border-[0.5px] border-[rgba(200,168,112,0.18)]" data-id="element-114" data-mp="33ml10h3yv9hn" data-mpi={i}>
                <CheckIcon className="w-5 h-5 text-secondary flex-shrink-0" data-id="element-115" data-mp="wxandv12n2oj" />
                <span className="text-foreground/90 font-body text-[15px] md:text-base font-medium leading-snug" data-id="element-116" data-mp="1knwvfmb2smyj">
                  {benefit}
                </span>
              </motion.div>)}
          </div>

          {/* Countdown */}
          <div className="space-y-4 pt-8 border-t border-border/30" data-id="element-117" data-mp="1bo9u10icjh5h">
            <p className="text-sm md:text-base text-foreground/80 font-body uppercase tracking-widest font-bold" data-id="element-118" data-mp="1flxrobbfbo12">
              Quedan para esta oferta especial:
            </p>
            <CountdownTimer minutes={263} data-id="element-119" data-mp="49eul1emhux1" />
          </div>
        </motion.div>

        {/* Footer */}
        <motion.footer initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="text-center space-y-4 pt-12 border-t border-border/20" data-id="element-120" data-mp="3st78689m4msn">
          <p className="text-foreground/70 font-body text-sm font-medium" data-id="element-121" data-mp="1ne5beatsabv">
            © 2026 Protocolo H.E.R. — Todos los derechos reservados.
          </p>
          <p className="text-foreground/60 font-body text-sm max-w-2xl mx-auto leading-relaxed" data-id="element-122" data-mp="3a1mqw2exk0uj">
            Descargo de responsabilidad médico: Este producto ofrece información
            general sobre salud hormonal. No constituye consejo médico
            profesional. Consulta siempre a un profesional de la salud antes de
            comenzar cualquier programa de dieta o ejercicio.
          </p>
        </motion.footer>
      </div>
    </section>;
}